module.exports = __webpack_public_path__ + "img/MainCocktailsMaker999.f19eb64a.jpg";